/* eslint-disable import/prefer-default-export */

export const AccessTokenKey = 'accessToken';
export const AUTH_STATE_COOKIE = 'auth_state';